import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WBSButton } from '@/common/WBSButton';
import FollowUpNetworkTable from '@/tables/FollowUpNetworkTable';
import { PageContainer } from '~/styles/boardStyles';
import { GroupHeaderWrapper, Title } from '~/styles/layoutElements';

export const Route = createFileRoute('/_app/follow-up-network/')({
  component: FollowUpNetworkScreen,
});

/**
 * `themes/wbs/buddypress/groups/single/follow-up-network.php` — the directory
 * list. Its header is `_e('Follow-up Network')` (`:2`) plus a single `View Map`
 * anchor at `.../follow-up-network/map` (`:4`).
 *
 * One cross-link, not a two-button segmented control with one disabled: legacy
 * renders exactly one anchor per template and the other view is its
 * destination.
 *
 * A bare `Title`, not `TitleWithQuestion`: legacy hangs no
 * `wbs_contextual_helper` off this heading, and `HelpModal` falls back silently
 * to its first item when an id does not match.
 */
function FollowUpNetworkScreen() {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <GroupHeaderWrapper>
        <Title>{t('wbs.follow-up-network')}</Title>
        <WBSButton as={Link} to="/follow-up-network/map" wide>
          {t('wbs.view-map')}
        </WBSButton>
      </GroupHeaderWrapper>
      <FollowUpNetworkTable />
    </PageContainer>
  );
}
